import {useEffect,useState,useContext} from 'react';
import {getApiUrl} from '../config/serverEndpoint';
import {LocalPlayerContext} from '../offline/LocalPlayerContext';
const {safeAppearance}=require('../offline/appearance');
const cache=new Map(),key=name=>String(name||'').toLowerCase();
const clean=active=>safeAppearance({cosmetics:active}).cosmetics;
export function notifyCosmetics(username,active){const owner=key(username);if(!owner)return;const value=clean(active);cache.set(owner,{at:Date.now(),value});window.dispatchEvent(new CustomEvent('kelimo-cosmetics-updated',{detail:{username:owner,active:value}}));}
export default function useCosmetics(username){
 const owner=key(username),local=useContext(LocalPlayerContext),profile=local?.players?.[owner];
 const localSelection=()=>{const saved=cache.get(owner);return saved?.value&&saved.at>(profile?.savedAt||0)?saved.value:profile?.cosmetics||{};};
 const [selection,setSelection]=useState(()=>({owner,value:local?localSelection():cache.get(owner)?.value||{}}));
 useEffect(()=>{let mounted=true;const show=value=>{if(mounted)setSelection({owner,value});};
  const changed=e=>{if(key(e.detail?.username)===owner)show(clean(e.detail.active));};
  window.addEventListener('kelimo-cosmetics-updated',changed);
  if(local)show(localSelection());
  else if(!owner||!sessionStorage.getItem('reconnectToken'))show({});
  else {
   let entry=cache.get(owner);
   if(entry?.value&&Date.now()-entry.at<30000)show(entry.value);
   else {
    show(entry?.value||{});
    if(!entry?.pending){const pending=fetch(getApiUrl(`/cosmetics/appearance?username=${encodeURIComponent(owner)}`),{cache:'no-store'}).then(async r=>{if(!r.ok)throw Error('Görünüm alınamadı.');return clean((await r.json()).active||{});});entry={...entry,pending};cache.set(owner,entry);}
    const request=entry;
    request.pending.then(value=>{
     // An equip action or newer request supersedes this reply, even if it arrives last.
     if(cache.get(owner)!==request){const latest=cache.get(owner);if(latest?.value)show(latest.value);return;}
     cache.set(owner,{value,at:Date.now()});show(value);
    }).catch(()=>{if(cache.get(owner)===request){if(request.value)cache.set(owner,{value:request.value,at:request.at});else cache.delete(owner);}});
   }
  }
  return()=>{mounted=false;window.removeEventListener('kelimo-cosmetics-updated',changed);};
 // The local provider changes when its verified profile is refreshed.
 },[owner,local]);
 return selection.owner===owner?selection.value:local?localSelection():{};
}
